<template>
  <section id="news" class="py-24 bg-white">
    <div class="container mx-auto px-6 md:px-14 md:py-14">
      <div class="text-center mb-16 reveal">
        <div class="accent-line mx-auto w-24 mb-4" />
        <h2 class="text-3xl md:text-4xl font-display font-bold mb-4 text-dark-text">
          <span class="text-gradient bg-gradient-to-r from-primary to-secondary">新闻动态</span>
        </h2>
        <p class="text-xl text-gray-300 max-w-2xl mx-auto font-bold">NEWS</p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <!-- 新闻卡片 -->
        <div
          v-for="(d, i) in news_data"
          :key="i"
          class="card-hover bg-light-gray rounded-2xl overflow-hidden shadow-sm border border-gray-100 reveal"
          :style="{ animationDelay: (0.1 + i * 0.1) + 's' }"
        >
          <router-link :key="i" :to="{path: '/index/newInfo', query: {id: d.id}}">
            <img :src="filePath + d.i" :alt="d.n" class="w-full h-48 object-cover">
            <div class="p-6 flex-box">
              <div style="height: 12rem">
                <div class="text-sm text-primary mb-3">{{ format_date(d.rt) }}</div>
                <h3 class="text-xl font-bold mb-3 text-dark-text">{{ d.n }}</h3>
                <p class="text-gray-600 mb-4">{{ d.c }}</p>
              </div>
              <div class="text-primary font-medium hover:underline inline-flex items-center">
                阅读更多 <i class="fa fa-angle-right ml-1" />
              </div>
            </div>
          </router-link>
        </div>
      </div>

      <div class="text-center mt-12 reveal">
        <router-link :to="url">
          <div class="card-hover inline-block gradient-border text-dark-text px-8 py-3 rounded-full font-medium transition-all hover:bg-light-gray">
            <a>
              {{ "浏览全部新闻" }} <i class="fa fa-arrow-right ml-2" />
            </a>
          </div>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { get_news_introduction_page } from '@/api/news'
import vv from '@/components/varVariable.vue'
import { get_head_data } from '@/api'

export default {
  name: 'News',
  data() {
    return {
      news_data: [],
      url: ''
    }
  },
  computed: {
    filePath() {
      return vv.fileHttp
    }
  },
  created() {
    this.get_news_data()
    get_head_data().then(d => {
      this.url = d.heads[1].u
    })
  },
  methods: {
    get_news_data() {
      const th = this
      th.loading = true
      const selectPage = {
        langType: 'zh',
        pageNum: 1,
        pageSize: 3
      }
      get_news_introduction_page(selectPage).then(data => {
        console.log(data)
        const dl = data.d.length
        for (let i = 0; i < dl; i++) {
          this.news_data.splice(this.news_data.length, 0, data.d[i])
        }
      }).finally(() => {
        th.loading = false
      })
    },
    format_date(t) {
      /* HH:mm:ss*/
      return this.$moment(new Date(t)).format('YYYY-MM-DD')
    }
  }
}
</script>

<style scoped>
/* 组件特定样式 */
</style>
